import { render, staticRenderFns } from "./tabBar.vue?vue&type=template&id=0d8c42d0&scoped=true"
import script from "./tabBar.vue?vue&type=script&lang=js"
export * from "./tabBar.vue?vue&type=script&lang=js"
import style0 from "./tabBar.vue?vue&type=style&index=0&id=0d8c42d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8c42d0",
  null
  
)

export default component.exports